import { render, staticRenderFns } from "./Unidadesam.vue?vue&type=template&id=2a766c58"
import script from "./Unidadesam.vue?vue&type=script&lang=js"
export * from "./Unidadesam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports